import { SHOW, HIDE } from '../actionTypes';

export const show = () => ({
  type: SHOW,
});

export const hide = () => ({
  type: HIDE,
});
